import { List, Record } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const CollectionStationsState = new Record({
    loading: false,
    error: null,
    stations: new List(),
    selectedStationNlc: null
});

export class CollectionStationsStore extends BaseStore {
    getActionHandlers () {
        return {
            [ActionTypes.GET_COLLECTION_STATIONS_STARTED]: this.handleGetCollectionStationStarted,
            [ActionTypes.GET_COLLECTION_STATIONS_ENDED]: this.handleGetCollectionStationEnded,
            [ActionTypes.GET_COLLECTION_STATIONS_FAILED]: this.handleGetCollectionStationFailed,
            [ActionTypes.KEYGO_REGISTRATION_STARTED]: this.handleSetCollectionStation,
        };
    }

    handleGetCollectionStationStarted () {
        this.setState(this.state.set('loading', true));
    }

    handleGetCollectionStationFailed ({error}) {
        this.setState(this.state.merge({loading: false, error}));
    }

    handleGetCollectionStationEnded ({stations}) {
        this.setState(this.state.merge({loading: false, stations}));
    }

    handleSetCollectionStation({collectionLocation}) {
        this.setState(this.state.set('selectedStationNlc', collectionLocation));
    }

    getInitialState () {
        return new CollectionStationsState();
    }

    getSelectedLocationName () {
        const locationObj = this.get('stations').find((location) => location.nlc === this.get('selectedStationNlc'));
        return locationObj ? locationObj.name : null;
    }
}

const storeInstance = new CollectionStationsStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/CollectionStationsStore.js